import { getHighlightedText } from '@/helpers/highlightedText';
import { Select } from '@monavate/ui-core';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Select as AntSelect } from 'antd';

const Option = AntSelect.Option;

const CardName = styled.div`
    font-size: 13px;
    font-weight: 500;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

const CardOption = styled.div`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
`;

const CardLast4 = styled.div``;

const SelectContainer = styled.div`
    .ant-select-selection-item {
        ${CardOption} {
            display: flex;
            flex-direction: row-reverse;
            justify-content: flex-end;
            gap: 8px;
        }
        ${CardName} {
            max-width: 100%;
        }
    }
`;

interface CardSelectorProps {
    options?: any[];
    defaultValue?: any;
    onChangeCallback: any;
    disabled?: boolean;
    dataTestId?: string;
}

const CardSelector: React.FC<CardSelectorProps> = ({
    options,
    defaultValue,
    onChangeCallback,
    disabled,
    dataTestId,
}) => {
    const [cardsSearchQuery, setCardsSearchQuery] = useState<string>('');
    const [availableCards, setAvailableCards] = useState<any[]>(options || []);
    const [value, setValue] = useState<any>();

    useEffect(() => {
        setValue(defaultValue || null);
    }, [defaultValue]);

    const onChange = (cardId: string) => {
        setValue(cardId);
        onChangeCallback(cardId);
    };

    return (
        <SelectContainer>
            <Select
                id="cards-list"
                dataTestId={dataTestId}
                disabled={disabled}
                value={value}
                placeholder="Select"
                popupClassName="single-scroll-popup"
                showSearch
                // @ts-ignore
                onChange={(cardId: string) => {
                    onChange(cardId);
                }}
                optionFilterProp={'label'}
                onSearch={(value: string) => {
                    setCardsSearchQuery(value);
                }}
                onSelect={() => {
                    setCardsSearchQuery('');
                }}
            >
                {availableCards.map((card: any, index: number) => {
                    return (
                        <Option
                            key={index}
                            value={card.id}
                            label={card.name ? `${card.panLast4} ${card.name}` : card.panLast4}
                        >
                            <CardOption>
                                {card.name && (
                                    <CardName>
                                        {getHighlightedText(card.name, cardsSearchQuery)}
                                    </CardName>
                                )}
                                {card.panLast4 && (
                                    <CardLast4>
                                        {getHighlightedText(card.panLast4, cardsSearchQuery)}
                                    </CardLast4>
                                )}
                            </CardOption>
                        </Option>
                    );
                })}
            </Select>
        </SelectContainer>
    );
};

export default CardSelector;
